
// TODO faire mieux
export const BACK_ENDPOINT = process.env.VUE_APP_BACK_ENDPOINT;
// export const CLUSTER_DOMAIN ="speachme.com"
export const CLUSTER_DOMAIN = process.env.VUE_APP_CLUSTER_DOMAIN;
export const VERSION_FRONT = process.env.VUE_APP_VERSION;
